/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EvaluationSubCriteriaImportanceScore {

    BASIC_ATTRIBUTE = 'BASIC_ATTRIBUTE',

    PERFORMANCE_ATTRIBUTE = 'PERFORMANCE_ATTRIBUTE',

    ENTHUSIASM_ATTRIBUTE = 'ENTHUSIASM_ATTRIBUTE',

    INDIFFERENT_ATTRIBUTE = 'INDIFFERENT_ATTRIBUTE',

    NOT_RELEVANT = 'NOT_RELEVANT'
}

